export default __webpack_public_path__ + "static/media/laundry2-after.13e9ae1f.jpg";